import type { Editor } from '@tiptap/react';

import { resolveElementRangeById } from '@modules/documents/helpers/scrollContent/scrollTargets';

import type { TAiContentSelection } from '../types';

/** False when the draft no longer holds those elements; the AI still gets the captured selection. */
const restoreAiEditSelection = (editor: Editor, selection?: TAiContentSelection): boolean => {
  if (!selection) return true;

  const ranges = selection.elementIds
    .map((id) => resolveElementRangeById(editor, id))
    .filter((range): range is NonNullable<typeof range> => Boolean(range));
  if (ranges.length !== selection.elementIds.length) return false;
  if (ranges.length === 0) return true;

  if (ranges.length === 1) {
    editor.commands.setNodeSelection(ranges[0].from);
    return true;
  }

  editor.commands.setTextSelection({
    from: Math.min(...ranges.map((range) => range.from)),
    to: Math.max(...ranges.map((range) => range.to)),
  });
  return true;
};

export default restoreAiEditSelection;
